import {Component, HostListener} from "@angular/core";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
    animations: [
        trigger("fade", [
            state("void", style({
                opacity: 0
            })),
            state("true", style({
                opacity: 1
            })),
            transition("* => *", animate("250ms 0s ease"))
        ])
    ],
    selector: "fui-canvas-storyboard",
    styleUrls: ["./canvas-storyboard.component.scss"],
    templateUrl: "./canvas-storyboard.component.html"
})
export class FUICanvasStoryboardComponent {

    @HostListener("resize", ["$event"])
    public resize($event: Event) {
        console.log($event);
    }
}
